import {request} from "@/util/request";

export function GetSendList(params) {
    return request({
        url: '/XXSB.asmx/GetSendList',
        method: 'GET',
        params
    })
}

export function GetRecipientList(params) {
    return request({
        url: '/XXSB.asmx/GetRecipientList',
        method: 'GET',
        params
    })
}

export function GetInfo(params) {
    return request({
        url: '/XXSB.asmx/GetInfo',
        method: 'GET',
        params
    })
}

export function doAdd(params) {
    return request({
        url: '/XXSB.asmx/Add',
        method: 'GET',
        params
    })
}

export function PageInit(params) {
    return request({
        url: '/XXSB.asmx/PageInit',
        method: 'GET',
        params
    })
}

export function WordToPdf(params) {
    return request({
        url: '/XXSB.asmx/docZpdf',
        method: 'GET',
        params
    })
}